import React, { Fragment } from 'react';
import clsx from 'clsx';
import {
  Avatar,
  Box,
  Button,
} from '@material-ui/core';
import { connect } from 'react-redux';
import ProgressBar from 'eebac/components/progress_bar';
import { motion } from "framer-motion";
import DataHelper from 'eebac/utils/dataHelper';
import { Link } from 'react-router-dom';

const MenuUserbox = props => {
  const { sidebarToggle, sidebarHover, userBoxData } = props;

  return (
    <Fragment>
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        exit="in"
        transition={{ duration: 1 }}>
        <Box
          className={clsx('app-sidebar-userbox', {
            'app-sidebar-userbox--collapsed': sidebarToggle && !sidebarHover
          })}>
          <Avatar
            alt={userBoxData.username}
            imgProps={{
              style: { objectFit: "fill" }
            }}
            src={DataHelper.addBase64ToImage(userBoxData.avatar)}
            className="app-sidebar-userbox-avatar bg-plum-plate-new"
          />
          <Box className="app-sidebar-userbox-name">
            <Box component="div" style={{ whiteSpace: "nowrap", overflow: "hidden", textTransform : "capitalize" }}
              textOverflow="ellipsis">
              <b>{userBoxData.username}</b>
            </Box>
            {userBoxData.score !== false && <ProgressBar title="Profile Score" valueNow={userBoxData.score} />}
            <Box className="app-sidebar-userbox-btn-profile">
              <Button
                size="small"
                color="secondary"
                variant="contained"
                className="text-white"
                component={Link}
                to={userBoxData.profileUrl}
              >
                View profile
            </Button>
            </Box>
          </Box>
        </Box>
      </motion.div>
    </Fragment>
  );
};

MenuUserbox.defaultProps = {
  userBoxData: {}
}

const mapStateToProps = state => ({
  sidebarToggle: state.ThemeOptions.sidebarToggle,
  sidebarHover: state.ThemeOptions.sidebarHover,
  userBoxData: state.USERBOX_DATA
});

export default connect(mapStateToProps)(MenuUserbox);
